import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

// Appends the shared "(optional)" suffix to a field label when the field is optional. The per-app Formik
// field wrappers use this so the suffix text and its rendering live in one place across both frontends.
export function useOptionalLabel(label: ReactNode, optional?: boolean): ReactNode {
  const { t } = useTranslation();

  return optional ? (
    <>
      {label} ({t("common.optional")})
    </>
  ) : (
    label
  );
}
